module.exports = __webpack_public_path__ + "img/public/SiteIcons/pendingicon.svg?e444fe01";